// BASED ON https://github.com/google/shaka-player/blob/master/lib/text/vtt_text_parser.js
import shaka from 'shaka-player';

function getSeconds(hours, minutes, secondsAndMillis) {
  const [seconds, millis] = secondsAndMillis.split('.');

  return (parseInt(millis, 10) / 1000) + parseInt(seconds, 10) + (parseInt(minutes, 10) * 60) + (parseInt(hours, 10) * 3600);
}

// 00:00.000 or 00:00:00.000 or 0:00:00.000
function parseTime(timeStr) {
  const segments = timeStr.split(':');

  switch (segments.length) {
    case 2: {
      return getSeconds('00', segments[0], segments[1]);
    }

    case 3: {
      return getSeconds(segments[0], segments[1], segments[2]);
    }

    default: {
      return 0;
    }
  }
}

// X-TIMESTAMP-MAP=LOCAL:00:00:00.000,MPEGTS:900000
export function parseTimestampHeader(timestampHeader) {
  const attrs = timestampHeader.split('=')[1].split(',')
    .map((attr) => {
      const pos = attr.indexOf(':');

      return [attr.substring(0, pos), attr.substring(pos + 1)];
    });

  return Object.fromEntries(attrs);
}

const MPEG_TIMESCALE = 90000;
//  At this value, timestamps roll over in TS content.
const TS_ROLLOVER = 0x200000000;

export function getOffset(block, timeContext) {
  // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
  const timestampHeader = block.split('\n')
    .find(line => line.startsWith('X-TIMESTAMP-MAP'));
  if (!timestampHeader) {
    return timeContext.segmentStart;
  }

  const attrs = parseTimestampHeader(timestampHeader);
  const localTime = parseTime(attrs.LOCAL);
  let mpegTime = parseInt(attrs.MPEGTS, 10);

  let segmentStart = timeContext.segmentStart;
  const rolloverSeconds = TS_ROLLOVER / MPEG_TIMESCALE;
  while (segmentStart >= rolloverSeconds) {
    segmentStart -= rolloverSeconds;
    mpegTime += TS_ROLLOVER;
  }

  // Apple-encoded HLS content uses absolute timestamps, so assume the
  // presence of the map tag means the content uses absolute timestamps.
  return timeContext.periodStart + mpegTime / MPEG_TIMESCALE - localTime;
}

/* 2
 * 00:02:20.000 --> 00:02:25.000
 * - Har en kopp te.
 * - Det smakar som te.
 */
export function parseBlock(block, timeOffset = 0) {
  const lines = block.split('\n');

  // skip comments
  if (lines[0].startsWith('NOTE')) {
    return null;
  }

  // skip styles
  if (lines[0].startsWith('STYLE')) {
    return null;
  }

  // drop cue id
  if (!lines[0].includes('-->')) {
    lines.splice(0, 1);
  }

  if (!lines[0]?.includes('-->')) {
    return null;
  }

  const [startStr, endStr] = lines[0].split('-->');
  const start = parseTime(startStr.trim()) + timeOffset;
  const end = parseTime(endStr.trim()) + timeOffset;

  const payload = lines.slice(1)
    .join('\n')
    .trim();

  return new shaka.text.Cue(start, end, payload);
}

// https://shaka-player-demo.appspot.com/docs/api/shaka.extern.TextParser.html
export default class VttParser {
  parseInit() {
  }

  parseMedia(data, timeContext) {
    const blocks = shaka.util.StringUtils.fromUTF8(data)
      .split(/(\r?\n){2,}/gm);

    const offset = getOffset(blocks[0], timeContext);

    return blocks.slice(1)
      .map(item => parseBlock(item, offset))
      .filter(Boolean);
  }
}
